import { createPaginatedListSlice } from './generators/paginatedList.store';

const slice = createPaginatedListSlice('users')

export const {
    usersGetListDataAction,
    usersSetListDataAction,
    usersSetPageAction,
    usersSetSliceAction,
    usersError
} = slice.actions

export default slice.reducer
